import styled from "styled-components";
import React, {
	ComponentPropsWithoutRef,
	CSSProperties,
	ReactNode,
} from "react";
import { Text, Button, ColorV2 } from "@adoptaunabuelo/react-components";
import media from "styled-media-query";
import ReCaptchaButton from "../button/ReCaptchaButton";
import ProtectedDonation from "../modal/ProtectedDonation";

const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: center;
`;
const Title = styled(Text)``;
const BottomButtonView = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	width: 100%;
	position: sticky;
	bottom: 0px;
	${media.lessThan("medium")`
		background-color: ${ColorV2.surface.background};
		margin: 0px -24px;
		padding: 8px 24px;
		width: 100%;
	`}
`;
const BottomButton = styled(Button)`
	width: 100%;
`;
const DataContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	justify-content: center;
	${media.lessThan("medium")`
		justify-content: flex-start;
	`};
`;
const ChildrenContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 32px 0px;
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
	width: -webkit-fill-available;
	width: -moz-available;
`;
const FooterSubtitle = styled(Text)`
	color: ${ColorV2.text.neutralMedium};
	text-align: center;
	width: -webkit-fill-available;
	width: -moz-available;
	margin-top: 8px;
`;

const SectionContainer = ({
	children,
	title,
	subtitle,
	buttonProps,
	secondaryButtonProps,
	protectedDonation,
	...props
}: SectionContainerProps) => {
	return (
		<Container {...props}>
			<DataContainer style={props.dataContainerStyle}>
				{protectedDonation && (
					<ProtectedDonation
						style={{ marginBottom: 16 }}
						type={protectedDonation}
					/>
				)}
				{title && (
					<Title type="h3" weight="semibold">
						{title}
					</Title>
				)}
				{subtitle && (
					<Text type="p2" style={{ marginTop: 8 }}>
						{subtitle}
					</Text>
				)}
				<ChildrenContainer {...props.childrenProps}>
					{children}
				</ChildrenContainer>
			</DataContainer>
			{buttonProps &&
				(buttonProps.action === "login" ? (
					<BottomButtonView
						style={{
							backgroundColor: buttonProps.backgroundColor,
							marginBottom: buttonProps.marginBottom,
						}}
					>
						<ReCaptchaButton
							action="login"
							{...buttonProps}
							style={{ width: "100%", ...buttonProps.style }}
						/>
					</BottomButtonView>
				) : (
					<BottomButtonView
						style={{
							backgroundColor: buttonProps.backgroundColor,
							marginBottom: buttonProps.marginBottom,
						}}
					>
						<Row>
							{buttonProps.LeftView}
							<BottomButton
								{...buttonProps}
								style={{
									width: buttonProps.LeftView
										? "unset"
										: "100%",
									...buttonProps.style,
								}}
							/>
						</Row>
						{buttonProps.subtitle && (
							<FooterSubtitle type="c2">
								{buttonProps.subtitle}
							</FooterSubtitle>
						)}
					</BottomButtonView>
				))}
			{secondaryButtonProps && (
				<BottomButtonView
					style={{
						backgroundColor: secondaryButtonProps.backgroundColor,
						marginBottom: secondaryButtonProps.marginBottom,
					}}
				>
					<Row>
						{secondaryButtonProps.LeftView}
						<BottomButton
							design={"secondary"}
							{...secondaryButtonProps}
							style={{
								border: "none",
								marginTop: 0,
								...secondaryButtonProps.style,
							}}
						/>
					</Row>
					{secondaryButtonProps.subtitle && (
						<FooterSubtitle type="c2">
							{secondaryButtonProps.subtitle}
						</FooterSubtitle>
					)}
				</BottomButtonView>
			)}
		</Container>
	);
};
export default SectionContainer;
export interface SectionContainerProps extends ComponentPropsWithoutRef<"div"> {
	title?: string;
	subtitle?: string;
	dataContainerStyle?: CSSProperties;
	childrenProps?: ComponentPropsWithoutRef<"div">;
	buttonProps?: SectionContainerButtonProps;
	secondaryButtonProps?: SectionContainerButtonProps;
	protectedDonation?: "donation" | "challenge" | "birthday";
}
export interface SectionContainerButtonProps {
	action?: "login";
	children: React.ReactNode;
	loading?: boolean;
	style?: CSSProperties;
	LeftView?: ReactNode;
	success?: boolean;
	disabled?: boolean;
	backgroundColor?: string;
	marginBottom?: string;
	subtitle?: string;
	onSuccess?: () => void;
	onClick?: (token?: any) => void;
}
